import { Vue, Component, Ref, Watch } from "vue-property-decorator";
import { GridRef } from "@/components/wijmo-grid/grid/grid";
import Grid from "@/components/wijmo-grid/grid/grid.vue";
import { CommonEntitiesLocale, CommonLocale } from "@/locales/localeid";
import { fmtMsg } from "@/commonui/utils";
import { Icon, Modal } from "ant-design-vue";
import { CommonEntitiesModule } from "@/modules/common-entities";
import { TeachingActivityModel } from "@/services/teaching-activity";
import { AccessLevel, ApplicationViews } from "@/util/enum";
import { getModule } from "vuex-module-decorators";
import AppSettings from "@/modules/app-settings";
import { VersionGroupModel } from "@/services/version-group";
import RichTextPreviewer from "@/components/rich-text-previewer/rich-text-previewer.vue";
import { disabledDueToAccessLevel, getRouteAccessLevel, pureRichText } from "@/util/func";
import { VersionGroupModule } from "@/modules/versiongroup";

@Component({
	components: {
		Icon,
		Grid,
		RichTextPreviewer
	}
})
export default class TeachingActivities extends Vue {
	@Ref() readonly gridCompRef!: GridRef;
	private appSettings = getModule(AppSettings);
	public CommonLocale = CommonLocale;
	public versionGroupModule = VersionGroupModule;
	public CommonEntitiesLocale = CommonEntitiesLocale;
	private CommonEntitiesModule = CommonEntitiesModule;
	public accessLevel = AccessLevel;

	get currentRouteAccessLevel() {
		return getRouteAccessLevel(this.$route);
	}

	get disabledDueToAccessLevel() {
		return disabledDueToAccessLevel(this.currentRouteAccessLevel);
	}

	get teachingActivities(): TeachingActivityModel[] {
		return this.CommonEntitiesModule.teachingActivities.map((activity) => ({
			...activity,
			title: pureRichText(activity.text),
			versionGroupName: this.versionGroups.find((version) => version.id == activity.versionGroupId)?.name,
			contentExposuresCount: activity.contentExposures?.length
		}));
	}

	get versionGroups(): VersionGroupModel[] {
		return CommonEntitiesModule.versionGroups;
	}

	localizedString(id: string, params?: {}) {
		return fmtMsg(id, params);
	}

	get loading() {
		return CommonEntitiesModule.loading;
	}

	get tagDefaultSort() {
		return {
			column: "text",
			ascending: true
		};
	}

	@Watch("appSettings.childMenuSelected", { immediate: true })
	getTeachingActivitiesStatistic(value) {
		if (value == ApplicationViews.TeachingActivities) {
			CommonEntitiesModule.getTeachingActivitiesStatistic();
		}
	}

	@Watch("CommonEntitiesModule.versionGroups")
	getTeachingActivitiesStatistics() {
		CommonEntitiesModule.setTeachingActivites([]);
		CommonEntitiesModule.getTeachingActivitiesStatistic();
	}

	showContentExposures(item) {
		if (item.contentExposures.length) {
			CommonEntitiesModule.setSelectedEntity(item);
			CommonEntitiesModule.setUsageModalVisible(true);
		}
	}

	editActivity(item) {
		CommonEntitiesModule.setIsEdit(true);
		CommonEntitiesModule.setSelectedEntity(item);
		CommonEntitiesModule.setVisibleModal(true);
	}

	onRemove(item) {
		const content =
			item.contentExposures && item.contentExposures.length
				? `${this.localizedString(CommonEntitiesLocale.CommonHasAssociatedDescriptionSecond)}
			${this.localizedString(CommonEntitiesLocale.CommonHasAssociatedDescriptionThird)}`
				: this.localizedString(CommonEntitiesLocale.CommonNoAssociatedDeleteActivity);
		Modal.confirm({
			class: "delete-activity",
			title: this.localizedString(CommonEntitiesLocale.CommonRemoveActivityText),
			content: content,
			okText: this.localizedString(CommonLocale.CommonOkButtonText),
			cancelText: this.localizedString(CommonLocale.CommonCancelButtonText),
			onOk: () => {
				CommonEntitiesModule.deleteTeachingActivity(item && item.id);
			},
			onCancel: () => {}
		});
	}
}
